import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
type Props = {}

const Hero: React.FC = (props: Props) => {
    const {t}  = useTranslation()
    return (
        <div className='main-home'>
            <button className='btn btn-black book-now' onClick={()=>window.open("https://live.ipms247.com/booking/book-rooms-ebreazehotel")}>{t('home.hero_section.book_now')}</button>
            <section className='banner home-banner'>
                <div className='overlay'></div>
                <div className='container'>
                    <div className='banner-info'>
                        <div className='banner-details'>
                            <div className='banner-title'>
                                <h4 className='title-highlight'>{t('home.hero_section.title')}</h4>
                                <h1>{t('home.hero_section.subtitle1')} <span>{t('home.hero_section.subtitle2')} </span></h1>
                            </div>
                            <div className='banner-search'>
                                <ul>
                                    <li>
                                        <div className='date-name'>
                                            <label>{t('home.hero_section.checkin_date')}</label>
                                            <span>21/12/2024</span>
                                        </div>
                                        <div className='date-icon'>
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='date-name'>
                                            <label>{t('home.hero_section.checkout_date')}</label>
                                            <span>23/12/2024</span>
                                        </div>
                                        <div className='date-icon'>
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='date-name'>
                                            <label>{t('home.hero_section.guest')}</label>
                                            <span>2</span>
                                        </div>
                                        <div className='date-plus'>
                                            <p>+</p>
                                            <p>-</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='date-name'>
                                            <label>{t('home.hero_section.room_type')}</label>
                                            <span>{t('home.hero_section.delux')}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <Link to='#' className='btn btn-gold'>{t('home.hero_section.search')}</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Hero;